import React, {useEffect, useState} from 'react'
import ReactApexChart from 'react-apexcharts'
import {Spin} from 'antd'
import {useIntl} from 'react-intl'
import TotalCard from './TotalCard'
import styles from './statistics.module.css'
import {formatNumber} from "../helper/Integer/IntegerFormatter";

export default function CategoryChart({ dataSet, loading }) {
  const lang = useIntl()
  const [data, setData] = useState({
    profit: { data: [], total: 0 },
    transaction: { data: [], total: 0 },
    product: [],
    balance: { currency: '', currency_text: '' },
  })

  useEffect(() => {
    if (dataSet) {
      parseData()
    }
  }, [dataSet])

  const parseData = () => {
    const { balance, chartData } = dataSet
    const { items, totalProfit, totalTransactions } = chartData
    const { product, profit, transaction } = items.reduce(
      (data, el) => {
        data.profit.push(el.profit)
        data.transaction.push(el.transaction)
        data.product.push(el.category.name)
        return data
      },
      { product: [], profit: [], transaction: [] }
    )
    setData({
      profit: { data: profit, total: totalProfit },
      transaction: { data: transaction, total: totalTransactions },
      product: product,
      balance: balance,
    })
  }

  const dataSeries = [
    {
      name: lang.formatMessage({id: 'profits'}),
      data: data.profit.data,
    },
    {
      name: lang.formatMessage({id: 'transactions'}),
      data: data.transaction.data,
    },
  ]

  const options = {
    chart: {
      type: 'bar',
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'straight',
    },
    title: {
      text: lang.formatMessage({id: 'profits_transactions_by_category'}),
      align: 'left',
    },
    grid: {
      row: {
        colors: ['#f3f3f3', 'transparent'],
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: data.product,
    },
    legend: {
      position: 'top',
    },
    yaxis: {
      labels: {
        formatter: (value) => {
          return formatNumber(value, data.balance.currency_text)
        },
      },
    },
  }

  return (
    <Spin spinning={loading}>
      <TotalCard
        totalProfit={data.profit.total}
        totalTransactions={data.transaction.total}
        balance={data.balance}
        className={styles.totalsCard}
      />
      <ReactApexChart
        className={styles.statisticsCharts}
        options={options}
        series={dataSeries}
        type='bar'
        height={300}
      />
    </Spin>
  )
}
